import { Component, Input } from '@angular/core';
import { MenuItem } from 'src/app/misc/interface/menu-item';

@Component({
  selector: 'app-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent {

  @Input() heading: string = "ﺑﻮاﺑﺔ اﻟﻤﻌﺮﻓﺔ ";
  @Input() sub_heading: string = "";
  @Input() breadcrumbs?: MenuItem[];
  @Input() type?: string = '';



}
